import styled from 'styled-components';

export const FooterBottom = styled.div`
  display: flex;
  font-size: ${({ dir }) => (dir === 'rtl' ? '10px' : '7px')};
  margin-bottom: 1rem;
  line-height: 1.3;
  letter-spacing: ${({ dir }) => (dir === 'rtl' ? 'normal' : '1.31px')};

  a {
    padding: 0 10px;
  }

  .copy {
    padding: 0 10px;
    margin: 0;
    color: #fff;

    @media (max-width: 575px) {
      margin: 0.75rem 0 0;
      border: none !important;
      width: 100%;
      text-align: center;
    }
  }

  @media (max-width: 575px) {
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 0px;
  }

  &[dir='ltr'] {
    a {
      border-left: 1px solid #fff;

      &:first-child {
        border: 0;
        padding-left: 0;
      }
    }

    .copy {
      border-left: 1px solid #fff;
    }
  }

  &[dir='rtl'] {
    a {
      border-right: 1px solid #fff;

      &:first-child {
        border: 0;
        padding-right: 0;
      }
    }

    .copy {
      border-right: 1px solid #fff;
    }
  }
`;
